import { render } from "./PrivateMainView.vue?vue&type=template&id=5c0f0f1b"
import script from "./PrivateMainView.vue?vue&type=script&lang=js"
export * from "./PrivateMainView.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__